import { ArchiveEnterprisePackageResponseSchema, AssignEnterprisePackageRequestSchema, CreateEnterprisePackageRequestSchema, EnterprisePackageMutationResponseSchema, EnterpriseSubscriptionResponseSchema, EnterpriseTenantActionRequestSchema, ExtendEnterprisePilotRequestSchema, GetEnterprisePackageResponseSchema, ListEnterprisePackagesRequestSchema, ListEnterprisePackagesResponseSchema, PackageIdParamSchema, RecordEnterprisePaymentRequestSchema, UpdateEnterprisePackageRequestSchema, } from '../../schemas.js';
/** REST contract for provider enterprise subscription and package routes. */
export const providerEnterpriseContract = {
    assignPackage: {
        method: 'POST',
        path: '/provider/enterprise-subscriptions/assign-package',
        body: AssignEnterprisePackageRequestSchema,
        response: EnterpriseSubscriptionResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to assign enterprise package',
    },
    extendPilot: {
        method: 'POST',
        path: '/provider/enterprise-subscriptions/extend-pilot',
        body: ExtendEnterprisePilotRequestSchema,
        response: EnterpriseSubscriptionResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to extend pilot',
    },
    recordPayment: {
        method: 'POST',
        path: '/provider/enterprise-subscriptions/record-payment',
        body: RecordEnterprisePaymentRequestSchema,
        response: EnterpriseSubscriptionResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to record payment',
    },
    expirePilot: {
        method: 'POST',
        path: '/provider/enterprise-subscriptions/expire-pilot',
        body: EnterpriseTenantActionRequestSchema,
        response: EnterpriseSubscriptionResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to expire pilot',
    },
    listPackages: {
        method: 'GET',
        path: '/provider/enterprise-packages',
        query: ListEnterprisePackagesRequestSchema,
        response: ListEnterprisePackagesResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'packages',
        errorMessage: 'Failed to list enterprise packages',
    },
    getPackageById: {
        method: 'GET',
        path: '/provider/enterprise-packages/:packageId',
        pathParams: PackageIdParamSchema,
        response: GetEnterprisePackageResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get enterprise package',
    },
    createPackage: {
        method: 'POST',
        path: '/provider/enterprise-packages',
        body: CreateEnterprisePackageRequestSchema,
        response: EnterprisePackageMutationResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to create enterprise package',
    },
    updatePackage: {
        method: 'PUT',
        path: '/provider/enterprise-packages/:packageId',
        pathParams: PackageIdParamSchema,
        body: UpdateEnterprisePackageRequestSchema,
        response: EnterprisePackageMutationResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to update enterprise package',
    },
    archivePackage: {
        method: 'DELETE',
        path: '/provider/enterprise-packages/:packageId',
        pathParams: PackageIdParamSchema,
        response: ArchiveEnterprisePackageResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to archive enterprise package',
    },
};
//# sourceMappingURL=provider-enterprise.contract.js.map